import API from "../axiosConfig";

export const getStreets = async () => {
  try {
    const response = await API.get("/streets");
    return response.data;
  } catch (error) {
    console.error("Error fetching streets:", error);
    throw error;
  }
};

export const getStreetById = async (id) => {
  try {
    const response = await API.get(`/streets/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStreetsBySectionId = async (sectionId) => {
  try {
    const response = await API.get("/streets/by_section/" + sectionId);
    return response.data;
  } catch (error) {
    console.error("Error fetching streets:", error);
    throw error;
  }
};

export const createStreet = async (sectionData) => {
  try {
    const response = await API.post("/streets", sectionData);
    return response.data;
  } catch (error) {
    console.error("Error creating section:", error);
    throw error;
  }
};

export const updateStreet = async (sectionId, sectionData) => {
  try {
    const response = await API.put(`/streets/${sectionId}`, sectionData);
    return response.data;
  } catch (error) {
    console.error("Error updating section:", error);
    throw error;
  }
};

export const deleteStreet = async (sectionId) => {
  try {
    const response = await API.delete(`/streets/${sectionId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting section:", error);
    throw error;
  }
};
